/**
 * Reasons `pages/ajaxCheckFacebookLinkDomainVerification` returns with a 4xx
 * instead of an ownership verdict. All three mean the profile's Facebook token
 * could not be used at all, so domain ownership is simply unknown — they must
 * not be reported to the user as "domain not verified".
 */
export const LINK_OWNERSHIP_TOKEN_FAILURE_REASONS = [
  'not_authorised',
  'no_page_token',
  'invalid_page_token',
] as const;

export type LinkOwnershipTokenFailureReason =
  (typeof LINK_OWNERSHIP_TOKEN_FAILURE_REASONS)[number];

export function getLinkOwnershipTokenFailureReason(
  error: unknown,
): LinkOwnershipTokenFailureReason | null {
  const reason = (
    error as { response?: { data?: { reason?: unknown } } } | undefined
  )?.response?.data?.reason;

  return (
    LINK_OWNERSHIP_TOKEN_FAILURE_REASONS.find(
      (candidate) => candidate === reason,
    ) ?? null
  );
}
